import React from "react";
import Help from "./Help";

// Wrapper that renders children alongside a help icon with a tooltip.
const HelpTooltip = ({ helpEnum, tooltipPosition, children, style }) => (
  <div style={{ display: "flex", alignItems: "center", ...style }}>
    {children}
    <Help helpEnum={helpEnum} tooltipPosition={tooltipPosition} />
  </div>
);

HelpTooltip.defaultProps = {
  tooltipPosition: "top-left",
};

export default HelpTooltip;
